import React, { useEffect, useRef, useState } from 'react';

const braille = ['⠋', '⠙', '⠹', '⠸', '⠼', '⠴', '⠦', '⠧', '⠇', '⠏'];
const strokes = ['/', '-', '\\', '|'];
const bars = ['▁', '▂', '▃', '▄', '▅', '▆', '▇', '█', '▇', '▆', '▅', '▄', '▃'];
const chars = {
  braille,
  strokes,
  bars,
};

type Props = {
  type?: 'braille' | 'strokes' | 'bars';
};

const ASCIILoader = ({ type = 'strokes' }: Props) => {
  const timeRef = useRef(null);
  const [charAnim, setCharAnim] = useState<string>(chars[type][0]);

  useEffect(() => {
    clearTimeout(timeRef.current);
    timeRef.current = setInterval(() => {
      setCharAnim((charAnim) => {
        const data = chars[type];
        const index = data.indexOf(charAnim);
        if (index === data.length - 1) {
          return data[0];
        }
        return data[index + 1];
      });
    }, 150);
    return () => {
      clearTimeout(timeRef.current);
    };
  }, []);

  return <span>...{charAnim}</span>;
};

export default ASCIILoader;
